// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FlowChart.css */
.flowchart-section {
    padding: 5rem 0;
    background: var(--secondary-dark);;
  }

  .whattoexpect {
    padding: 80px 0;
    background: #E3EFF0;
  }
  
  .flowchart-container {
    max-width: 800px;
    margin: 0 auto;
    position: relative;
  }

  .section-subtitle{
    text-align: center;
  }
  
  .flowchart-step {
    display: flex;
    align-items: flex-start;
    gap: 1.5rem;
    padding: 1.5rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    margin-bottom: 1.5rem;
    position: relative;
    z-index: 1;
  }
  
  .step-number {
    background: var(--text-medium);
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2rem;
    flex-shrink: 0;
  }

  .flowchart-section .section-title{
    color: var(--text-medium);
  }

  .flowchart-section .section-title::after{
    background-color: var(--text-medium);
  }
  
  .step-content h3 {
    color: var(--text-medium);
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
  }
  
  .step-content p {
    color: #5a6a7a;
    line-height: 1.6;
  }
  
  .flowchart-connector {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: -0.5rem 0;
    position: relative;
    z-index: 0;
  }
  
  .connector-line {
    width: 2px;
    height: 50px;
    background: #b6bec9;
   margin-bottom: 20px;
  }
  
  .connector-arrow {
    color: #94a3b8;
    font-size: 1.2rem;
    line-height: 2;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .flowchart-step {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    
    .step-number {
      margin-bottom: 1rem;
    }
    
    .connector-line {
      height: 20px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/flowchart/flowchart.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;GACpB,mBAAmB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,cAAc;EAChB;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,YAAY;IACd;EACF","sourcesContent":["/* FlowChart.css */\n.flowchart-section {\n    padding: 5rem 0;\n    background: var(--secondary-dark);;\n  }\n\n  .whattoexpect {\n    padding: 80px 0;\n    background: #E3EFF0;\n  }\n  \n  .flowchart-container {\n    max-width: 800px;\n    margin: 0 auto;\n    position: relative;\n  }\n\n  .section-subtitle{\n    text-align: center;\n  }\n  \n  .flowchart-step {\n    display: flex;\n    align-items: flex-start;\n    gap: 1.5rem;\n    padding: 1.5rem;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    margin-bottom: 1.5rem;\n    position: relative;\n    z-index: 1;\n  }\n  \n  .step-number {\n    background: var(--text-medium);\n    color: white;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 1.2rem;\n    flex-shrink: 0;\n  }\n\n  .flowchart-section .section-title{\n    color: var(--text-medium);\n  }\n\n  .flowchart-section .section-title::after{\n    background-color: var(--text-medium);\n  }\n  \n  .step-content h3 {\n    color: var(--text-medium);\n    margin-bottom: 0.5rem;\n    font-size: 1.2rem;\n  }\n  \n  .step-content p {\n    color: #5a6a7a;\n    line-height: 1.6;\n  }\n  \n  .flowchart-connector {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: -0.5rem 0;\n    position: relative;\n    z-index: 0;\n  }\n  \n  .connector-line {\n    width: 2px;\n    height: 50px;\n    background: #b6bec9;\n   margin-bottom: 20px;\n  }\n  \n  .connector-arrow {\n    color: #94a3b8;\n    font-size: 1.2rem;\n    line-height: 2;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .flowchart-step {\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n    }\n    \n    .step-number {\n      margin-bottom: 1rem;\n    }\n    \n    .connector-line {\n      height: 20px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
